<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <!-- <b-button
          class="mr-2"
          variant="dark"
          @click="opeSetAutoApplyModal()"
        >
          查詢設定自動扣款資料
        </b-button>

        <b-button
          class="mr-2"
          variant="warning"
          @click="selectFile('batch_remove_auto_bill', '.csv')"
        >
          批次銷自動扣款帳單
        </b-button>

        <b-button class="mr-2" variant="primary" @click="getUrgeBill()">列印2期催繳通知書</b-button>

        <b-button class="mr-2" variant="info" @click="allUnpaidBills()">列印當月全部未繳帳單</b-button>

        <b-button class="mr-2" variant="success" @click="exportBill()">匯出未繳費帳單</b-button> -->

        <b-button class="mr-2" variant="dark" v-auth="`update`" @click="openBatchContractRemoveBillModal()">契約批次銷帳</b-button>

        <b-button class="mr-2" variant="warning" v-auth="`update`" @click="selectFile('batch_remove_bill')">批次銷帳單</b-button>

        <input :ref="data.refsName" type="file" v-auth="`update`" @change="fileUpload()" :accept="data.uploadAccept" />

        <b-dropdown text="更多" variant="primary">
          <b-dropdown-item
            @click="selectFile('batch_remove_auto_bill', '.csv')"
          >
            批次銷自動扣款帳單
          </b-dropdown-item>

          <b-dropdown-item
            @click="selectFile('batch_remove_bank_bill', '.csv')"
          >
            批次銷帳單(台中商銀)
          </b-dropdown-item>

          <b-dropdown-item
            @click="getUrgeBill()"
          >
            列印2期催繳通知書
          </b-dropdown-item>

          <b-dropdown-item
            @click="allUnpaidBills()"
          >
            列印當月全部未繳帳單
          </b-dropdown-item>

          <b-dropdown-item
            @click="exportBill()"
          >
            匯出未繳費帳單
          </b-dropdown-item>

          <b-dropdown-item
            @click="opeSetAutoApplyModal()"
          >
            查詢設定自動扣款資料
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-select v-model="search.receive" :options="billReceiveMethod">
          <template #first>
            <b-form-select-option :value="null" disabled>-- 帳單領取方式 --</b-form-select-option>
            <b-form-select-option value="">全部</b-form-select-option>
          </template>
        </b-form-select>

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="契約編號"
          v-model="search.number"
          @keyup.enter="getBill(1)" />

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務編號"
          v-model="search.sales_number"
          @keyup.enter="getBill(1)" />

        <div class="blur">
          <b-form-input
            placeholder="關鍵字"
            v-model="search.blur"
            @keyup.enter="getBill(1)" />

          <div id="blur_info" class="blur-info">i</div>
        </div>

        <date-picker
          v-model="search.updated_date_S"
          :position="'right'"
          placeholder="異動日期開始"
        ></date-picker>

        <date-picker
          v-model="search.updated_date_E"
          :position="'right'"
          placeholder="異動日期結束"
        ></date-picker>
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getBill(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <b-tooltip
      target="blur_info"
      placement="top"
      title="契約編號、業務編號、互助人、要助人身分證" />

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getBill"
      tableId="unpaidBills"
    >
      <template #cell(order_create)="row">
        <h4>
          <b-badge :variant="row.item.order_create ? 'warning': 'light'">{{ row.item.order_create ? '已合併': '未合併' }}</b-badge>
        </h4>
      </template>

      <template #cell(function)="row">
         <b-button
          variant="primary"
          size="sm"
          v-auth="`update`"
          @click="openRemoveBillModal(row.item)"
        >
          銷帳
        </b-button>
        <b-button
          variant="info"
          size="sm"
          @click="generateBill(row.item)"
        >
          下載帳單
        </b-button>
      </template>
    </tables-page>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :enableDownload="print.enableDownload"
      :isIframePreviewPdf="print.isIframePreviewPdf"
      :filename="print.filename"
      :params="print.pdfParams"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
          <bill v-if="print.type === 'bill'" :data="data.temp_table_data"></bill>

          <payment-reminder-notice
            v-else-if="print.type === 'paymentReminderNotice'"
            v-for="(item, index) in print.list"
            :key="index"
            :data="item"
          ></payment-reminder-notice>
      </template>
    </html-to-pdf>

    <export-bill-modal v-model="status.exportBillModal" />

    <!-- 銷帳 modal -->
    <remove-bill-modal
      v-model="status.removeBillModal"
      :data="data.temp_table_data"
      @sumit="removeBill" />

    <!-- 批次銷帳 & 批次銷自動扣款帳單 & 批次銷帳單(台中商銀)，回傳資料顯示 modal -->
    <batch-remove-bill-modal
      v-model="status.batchRemoveBillModal"
      :data="data.callbackBatchRemoveBill"
      :title="data.callbackBatchRemoveTitle"
      :isAutoBill="status.isAutoBill" />

    <!-- 契約批次銷帳 modal -->
    <batch-contract-remove-bill-modal
      ref="batch_contract_remove_bill_modal"
      v-model="status.batchContractRemoveBillModal"
      @sumit="removeBill" />

    <!-- 查詢設定自動扣款資料 modal -->
    <set-auto-apply-modal v-model="status.setAutoApplyModal" mode="bill"/>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import ExportBillModal from"./components/modal/ExportBillModal";
import RemoveBillModal from"./components/modal/RemoveBillModal";
import BatchRemoveBillModal from"./components/modal/BatchRemoveBillModal";
import BatchContractRemoveBillModal from"./components/modal/BatchContractRemoveBillModal";
import billApi from "@/models/API/billApi";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import Bill from '@/components/common/PrintTemplate/Bill';
import { checkUpdateFile } from "@/models/HELPERS/common.js";
import { billReceiveMethod } from "@/models/HELPERS/options.js";
import PaymentReminderNotice from '@/components/common/PrintTemplate/PaymentReminderNotice';
import qs from 'qs';
import SetAutoApplyModal from"@/components/common/modal/SetAutoApplyModal";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'unpaidBills',
  components: {
    BreadCrumb,
    TablesPage,
    Bill,
    HtmlToPdf,
    ExportBillModal,
    RemoveBillModal,
    BatchRemoveBillModal,
    BatchContractRemoveBillModal,
    PaymentReminderNotice,
    SetAutoApplyModal,
    datePicker
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '帳單管理', url: '', isActive: true },
          { name: '未繳帳單', url: '', isActive: false }
        ]
      },
      search: {
        receive: null,
        number: '',
        sales_number: '',
        blur: '',
        updated_date_S: '',
        updated_date_E: ''
      },
      status: {
        exportBillModal: false,
        resetDom: false,
        removeBillModal: false,
        batchRemoveBillModal: false,
        batchContractRemoveBillModal: false,
        setAutoApplyModal: false,
        isAutoBill: false
      },
      data: {
        table_data: [],
        table_fields: [
          // {
          //   key: "period",
          //   label: "帳單期別",
          // },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人",
            sortable: true
          },
          {
            key: "sales_number",
            label: "業務編號",
            sortable: true
          },
          {
            key: "pay_ID_number",
            label: "要助人身分證",
            sortable: true
          },
          {
            key: "total_1",
            label: "未繳金額"
          },
          {
            key: "order_create",
            label: "合併狀態"
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_sort: {
          sortBy: '',
          sort: ''
        },
        page: {},
        temp_table_data: {},
        callbackBatchRemoveBill: [],
        uploadAccept: '',
        refsName: '',
        callbackBatchRemoveTitle: ''
      },
      billReceiveMethod,
      print: {
        list: [],
        type: null,
        filename: '',
        enableDownload: false,
        isIframePreviewPdf: true,
        pdfParams: {
          format: 'a4',
          orientation: 'p'
        }
      },
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.billApi.page);
      this.getBill();
    },
    allUnpaidBills () {
      const routeUrl = this.$router.resolve({ path: "/backstage/yf/currentMonthBill"});
      window.open(routeUrl.href, '_blank');
    },
    // 查詢帳單
    getBill(pageIndex = null, sortBy = '', sort = '') {
      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      const params = {
        ...this.search,
        'sortBy': this.data.table_sort.sortBy,
        'sort': this.data.table_sort.sort,
        'class': 1,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.billApi.getBill((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 產生帳單(PDF)
    async generateBill(item = null) {
      this.status.resetDom = true;
      this.print = {
        type: 'bill',
        filename: '帳單',
        enableDownload: false,
        isIframePreviewPdf: true,
        pdfParams: {
          format: 'a4',
          orientation: 'p'
        }
      };

      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
      // this.$refs.htmlToPdf.zipPdf();
    },
    // 開啟銷帳modal
    openRemoveBillModal(item = null) {
      this.status.removeBillModal = true;

      const data = {
        ...item,
        details: item.details.map(details_item => {
          return {
            ...details_item,
            payment_at: '',
            payment_source: ''
          }
        })
      }
      this.data.temp_table_data = Object.assign({}, data);
    },
    // 開啟契約批次銷帳modal
    openBatchContractRemoveBillModal() {
      this.status.batchContractRemoveBillModal = true;
    },
    // 銷帳單
    removeBill(details = []) {
      let checkbox_count = 0;

      for (let i = 0 ; i < details.length; i++) {
        if (details[i].checkbox) {
          checkbox_count ++;

          const required =
            ['payment_source',
            'payment_at'];
          const status = required.every(item =>  details[i][item] != null && details[i][item] !== '' );

          if (!status) {
            const result = { message: '欄位請填寫完整', title: '銷帳' };
            this.billApi.toast(() => {}, result, false);

            return;
          }
        }
      }

      if (checkbox_count === 0) return;

      const r = confirm("確定要銷帳單？");

      if (r) {
        const params = qs.stringify({
          'details': JSON.stringify(details.filter(filter_item => filter_item.checkbox).
            map(map_item => {
              return {
                ...map_item,
                class: 0
              }
           })),
        })

        this.billApi.multiRemoveBill((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: '銷帳成功', title: '未繳帳單' };

            this.getBill();

            this.status.removeBillModal = false;
            this.status.batchContractRemoveBillModal = false;

            this.$refs.batch_contract_remove_bill_modal.resetSearchCondition();
          } else if (res.code === 1) {
            result = { message: '銷帳失敗，請重新確定銷帳資訊是否正確', title: '未繳帳單' };
          }

          this.billApi.toast(() => {}, result, res.code === 0);
        }, params, false)

        return true;
      }

      return false;
    },
    // 匯出未繳費帳單
    exportBill() {
      this.status.exportBillModal = true;
    },
    // 選擇檔案
    selectFile(refsName = 'batch_remove_bill', accept = ''){

      this.data.refsName = refsName;
      this.data.uploadAccept = accept;

      this.$nextTick(() => {
        // 初始化檔案輸入值，防止上傳相同檔案沒作用
        this.$refs[refsName].value = '';

        const file_input_element = this.$refs[refsName];

        file_input_element.click();
      })


    },
    // 檔案上傳
    fileUpload() {
      const file_event = this.$refs[this.data.refsName];
      const file = this.$refs[this.data.refsName].files[0];
      const limit_mb = 20; // 限制檔案大小
      const file_accept = file_event.accept.split(".").join('').replace(/,/g, '/'); // 限制檔案類型
      const check_status = checkUpdateFile(file, file_accept, limit_mb);

      // 判斷檔案類型是否符合格式 & 大小限制20MB
      if (check_status) {
        if (this.data.refsName === 'batch_remove_bill') this.batchRemoveBill(file);
        else if (this.data.refsName === 'batch_remove_auto_bill') this.batchRemoveAutoBill(file);
        else if (this.data.refsName === 'batch_remove_bank_bill') this.batchRemoveBankBill(file);
      } else {
        const result = { message: `只能上傳${file_accept}檔案，大小上限為${limit_mb}MB`, title: '批次銷帳' };
        this.billApi.toast(() => {}, result, false);
      }
    },
    /**
     * 批次銷帳
     * @param {Event} file 檔案
     */
    batchRemoveBill(file) {
      const form_data = new FormData();

      form_data.append('file', file);

      this.billApi.batchRemoveBill((response) => {
        const res = response.data;
        let result = {};

        if (res.code === 0) {
          result = { message: '更新成功', title: '批次銷帳' };

          this.data.callbackBatchRemoveBill = res.data;
          this.data.callbackBatchRemoveTitle = '批次銷帳';
          this.status.isAutoBill = false;

          this.timeout = setTimeout(() => {
            this.status.batchRemoveBillModal = true;
          }, 1000);
        } else if (res.code === 1 ) {
          result = { message: '更新失敗，請重新上傳', title: '批次銷帳' };
        }

        this.billApi.toast(() => {}, result, res.code === 0);
      }, form_data)
    },
    /**
     * 批次銷自動扣款帳單
     * @param {Event} file 檔案
     */
    batchRemoveAutoBill(file) {
      const form_data = new FormData();

      form_data.append('file', file);

      this.billApi.batchRemoveAutoBill((response) => {
        const res = response.data;
        let result = {};

        if (res.code === 0) {
          result = { message: '更新成功', title: '批次銷自動扣款帳單' };

          this.data.callbackBatchRemoveBill = res.data;
          this.data.callbackBatchRemoveTitle = '批次銷自動扣款帳單';
          this.status.isAutoBill = true;

          this.timeout = setTimeout(() => {
            this.status.batchRemoveBillModal = true;
          }, 1000);
        } else if (res.code === 1 ) {
          result = { message: '更新失敗，請重新上傳', title: '批次銷自動扣款帳單' };
        }

        this.billApi.toast(() => {}, result, res.code === 0);
      }, form_data)
    },
    /**
     * 批次銷帳單(台中商銀)
     * @param {Event} file 檔案
     */
    batchRemoveBankBill(file) {
      const form_data = new FormData();

      form_data.append('file', file);

      this.billApi.batchRemoveBankBill((response) => {
        const res = response.data;
        let result = {};

        if (res.code === 0) {
          result = { message: '更新成功', title: '批次銷帳單(台中商銀)' };

          this.data.callbackBatchRemoveBill = res.data;
          this.data.callbackBatchRemoveTitle = '批次銷帳單(台中商銀)';
          this.status.isAutoBill = false;

          this.timeout = setTimeout(() => {
            this.status.batchRemoveBillModal = true;
          }, 1000);
        } else if (res.code === 1 ) {
          result = { message: '更新失敗，請重新上傳', title: '批次銷帳單(台中商銀)' };
        }

        this.billApi.toast(() => {}, result, res.code === 0);
      }, form_data)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        receive: null,
        number: '',
        sales_number: '',
        blur: '',
        updated_date_S: '',
        updated_date_E: ''
      }

      this.getBill(1);
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$set(this.data, 'printType', null);
      this.$forceUpdate();
    },
    // 查詢2期催繳通知書
    getUrgeBill() {
      this.status.resetDom = true;
      this.print = {
        type: 'paymentReminderNotice',
        filename: '2期催繳通知書',
        enableDownload: true,
        isIframePreviewPdf: false,
        pdfParams: {
          format: 'a5',
          orientation: 'l'
        }
      };

      this.billApi.getUrgeBill(async(response) => {
        const res = response.data;

        this.print.list = res.data;

        this.$forceUpdate();
        await this.$nextTick();

        this.$refs.htmlToPdf.generatePdf();
      })
    },
    // 開啟查詢設定自動扣款資料 modal
    opeSetAutoApplyModal() {
      this.status.setAutoApplyModal = true;
    },
  }
}
</script>

<style lang="scss" scoped>
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="file"] {
  display: none;
}

.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
    .blur {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      .blur-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        font-size: 12px;
        background: #17A2B8;
        color: #FFF;
      }
    }
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/unpaidBills.vue